import axios from "axios";
import { domain } from "../util/Constants";
import store from "@/store";

const http = new axios.create({
  baseURL: domain,
});

let idleTimer = null;
const idleTime =  86400; // 1 วัน = 86400 วินาที

// ตรวจสอบ token expiry ตอนโหลดหน้า
function checkTokenExpiry() {
  setInterval(() => {
    const expiry = localStorage.getItem("token_expiry");
    if (expiry && Date.now() > parseInt(expiry, 10)) {
      // ถ้าต้องการเคลียร์ token ให้ uncomment บรรทัดนี้
      store.dispatch("Auth/clearToken");  
      localStorage.removeItem("token_expiry"); 
      
    } 
  }, 5000); // ตรวจสอบทุก 5 วินาที
}

// ตั้ง timer ใหม่
function resetIdleTimer() {
  // เคลียร์ timer เก่า
  if (idleTimer) clearTimeout(idleTimer);

  // ตั้งเวลาใหม่
  const expiry = Date.now() + idleTime * 1000;
  localStorage.setItem("token_expiry", expiry); 
}

// เรียกเช็ค token ตอนโหลดหน้า
checkTokenExpiry();

// Interceptor สำหรับ request → reset timer ทุกครั้งที่ยิง API
http.interceptors.request.use(
  (config) => {
    resetIdleTimer();
    return config;
  },
  (error) => Promise.reject(error)
);

const httpMethod = {
  get(url, options = null) {
    return http.get(url, options).then((res) => res.data);
  },
  post(url, data = null, options = null) {
    return http.post(url, data, options).then((res) => res.data);
  },
  put(url, data = null, options = null) {
    return http.put(url, data, options).then((res) => res.data);
  },
  delete(url, options = null) {
    return http.delete(url, options).then((res) => res.data);
  },
};

export default httpMethod;
